import { createTheme } from "@mui/material/styles";

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: "#2F324C",
    },
    secondary: {
      main: "#126550",
    },
  },
});

export default theme;
